import { useDispatch } from 'react-redux';
import { Button, Container, Spacer } from '@vinted/web-ui';
import SeparatedList from 'components/SeparatedList';
import useTranslate from 'hooks/useTranslate';
import useTracking from 'hooks/useTracking';
import { actions as authActions } from 'state/auth/slice';
import { ITEM_UPLOAD_URL, GUIDE_ENTRIES_URL } from 'constants/routes';
import { urlWithParams } from 'libs/utils/url';
import { AccessChannel } from 'constants/index';
import { clickEvent } from 'libs/common/event-tracker/events';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const LoginSection = _ref => {
  let {
    user
  } = _ref;
  const translate = useTranslate('header.side_bar');
  const dispatch = useDispatch();
  const {
    track
  } = useTracking();

  const openAuthModal = () => {
    dispatch(authActions.openAuthModal());
    const trakingEvent = clickEvent({
      target: ClickableElement.Login
    });
    track(trakingEvent);
  };

  const handleSellNow = () => {
    const trakingEvent = clickEvent({
      target: ClickableElement.UploadItem
    });
    track(trakingEvent);
  };

  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsxs(SeparatedList, {
      separator: /*#__PURE__*/_jsx(Spacer, {}),
      children: [/*#__PURE__*/_jsx(Button, {
        text: translate('sell_now'),
        styling: Button.Styling.Filled,
        url: ITEM_UPLOAD_URL,
        onClick: handleSellNow,
        testId: "side-bar-sell-btn"
      }), !user && /*#__PURE__*/_jsx(Button, {
        text: translate('sign_in'),
        onClick: openAuthModal,
        testId: "side-bar-signin-btn"
      }), /*#__PURE__*/_jsx(Button, {
        text: translate('guide'),
        styling: Button.Styling.Flat,
        testId: "side-bar-guide-btn",
        url: urlWithParams(GUIDE_ENTRIES_URL, {
          access_channel: AccessChannel.VintedGuide
        })
      })]
    })
  });
};

export default LoginSection;